module.exports = __webpack_public_path__ + "img/96760.1d8f81a9.svg";